module.exports = __webpack_public_path__ + "afff4fdaccbbdd41387110ee5fc52fa2.pdf";